<ng-container *transloco="let t;">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title" id="assistedAccessDialogLabel">{{
                    t("schema.othersaccess.header")}}</h2>
                <button type="button" class="btn-close" data-bs-dismiss="modal"
                [attr.aria-label]="t('schema.othersaccess.close')" (click)="resetInputs()">
                </button>
            </div>
            <div class="modal-body">
                <p>{{ t("schema.othersaccess.description") }}</p>
                <form [formGroup]="assistedAccessForm">
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="assitedAccessGroupText" for="cprNumber">
                            {{t("schema.othersaccess.cpr") }}
                        </span>
                        <input id="cprNumber" formControlName="cprNumber" type="text" class="form-control"
                            aria-label="userId" required>
                    </div>
                </form>
                <p *ngIf="hasError" class="fst-italic text-danger">{{ t(errorText)}}</p>
            </div>
            <div class="modal-footer">
                <ng-container>
                    <button class="btn btn-warning" type="submit" (click)="onConfirm()">
                        {{ t("schema.othersaccess.continue")}}
                    </button>
                    <button class="btn wp-btn" type="button" [attr.aria-label]="t('schema.othersaccess.back')"
                    data-bs-dismiss="modal" (click)="resetInputs()">
                        {{ t("schema.othersaccess.back") }}
                    </button>
                </ng-container>
            </div>
        </div>
    </div>

    <ng-template #loadingState>
        <loading-spinner-border size="md"></loading-spinner-border>
    </ng-template>

</ng-container>